import SectionHeading from "@/components/feature/SectionHeading";
import { processSteps } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="复盘方法"
          title="一篇复盘是怎么写出来的"
          desc="固定的四步结构，让每个事件都按同样的路径被拆解，也方便你对照判断信息是否完整。"
        />

        <ol className="mt-10 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((step, index) => (
            <li key={step.step} className="relative">
              <div className="flex items-center gap-3">
                <span className="font-heading text-3xl font-bold text-primary-200">{step.step}</span>
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">{step.desc}</p>
              {index < processSteps.length - 1 && (
                <span className="absolute right-0 top-4 hidden h-px w-10 bg-background-300 lg:block"></span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}